module.exports = __webpack_public_path__ + "img/measurement_info_back_chest_right.d1880153.jpg";